import { memoize } from "es-toolkit";

import type { NodeDesignsState } from "../types.ts";

export const findNodeIdByTypeId: (nodeDesignsState: NodeDesignsState, typeId: string) => number | undefined = memoize(
  (nodeDesignsState, typeId) =>
    Object.entries(nodeDesignsState.designsById)
      .filter(([, design]) => design.typeId === typeId)
      .map(([id]) => Number(id))[0],
);

export const findParentlessNodeId: (nodeDesignsState: NodeDesignsState) => number | undefined = (nodeDesignsState) =>
  Object.keys(nodeDesignsState.designsById)
    .map(Number)
    .find((id) => !(id in nodeDesignsState.parentIdByChildId));
